/* eslint-env browser */

'use strict';

const { setShellEventOrRun } = require('@grpn/shell-page');

require('./index.styl');

require('../old_base/index.js');
require('../vendor/moment');

const {
  critModules,
  nonCritModules,
  pageReadyModules,
} = require('./js_modules');

const jsInitializer = require('../initializers/js_initializer');

setShellEventOrRun(() =>
  jsInitializer
    .addJsFiles(critModules, nonCritModules, pageReadyModules)
    .initialize()
);
